import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingService } from '@cf/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[cf-loader-container]',
  imports: [MatProgressBarModule, MatProgressSpinner, AsyncPipe],
  template: `
    <ng-container>
      @if ((loadingService.loadingState$ | async) && showLoader) {
        <ng-container>
          <div class="overlay"></div>
          @if (type === 'progress') {
            <mat-progress-bar
              [class.top-0]="position === 'top'"
              [class.bottom-0]="position === 'bottom'"
              mode="indeterminate"
            ></mat-progress-bar>
          } @else {
            <mat-spinner [diameter]="32" class="mx-auto my-3"></mat-spinner>
          }
        </ng-container>
      }

      <ng-content></ng-content>
    </ng-container>
  `,
  styleUrls: ['./loader-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderContainerComponent {
  @Input() position: 'top' | 'bottom' = 'top';

  @Input() showLoader = true;

  @Input() type: 'progress' | 'spinner' = 'progress';

  constructor(public readonly loadingService: LoadingService) {}
}
